import { KeyLabel } from '../domain/key-label.model';

export enum VodService {
  OTT_STUDIO = 'OTT_STUDIO'
}

export const VodServiceLabels = {
  [VodService.OTT_STUDIO]: 'OTT Studio',
  ott_studio: 'OTT Studio' // Backend returns lowercase version
};

export const VodServiceKL = () =>
  Object.keys(VodService).map((key) => new KeyLabel<VodService>(VodService[key], VodServiceLabels[VodService[key]]));

export const VodServiceList = Object.values(VodService);
